// extracted by mini-css-extract-plugin
export default {"item":"MenuGroup_item__-XahP","container":"MenuGroup_container__9vhpX","selected":"MenuGroup_selected__KEWDV"};